<template>
  <v-dialog
    v-model="dialog"
    width="360px">
    <div class="dialog-container">
      <h2>Mark as Sent to Insurer</h2>
      <p>
        Are you sure to mark this as sent to
        insurer?
      </p>
      <p>
        You will not be able to undo this
        endorsement. This cannot be unsent.
      </p>
      <div class="dialog-footer">
        <div>
          <v-button @click="dialog = false">Cancel</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="handlerYes">Yes</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { sendEndorsementInsurer } from '@/api/endorsement'
export default {
  name: 'MarkSentInsurer',
  props: {
    id: [String, Number]
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerYes() {
      this.network().sendEndorsementInsurer()
    },
    network() {
      return {
        sendEndorsementInsurer: async () => {
          const { data } = await sendEndorsementInsurer({
            id: this.id
          })
          this.$emit('done')
          this.dialog = false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .dialog-container {
    padding: 15px;
    p {
      padding-bottom: 15px;
      font-size: 16px;
        color: #616266;
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
    }
  }
</style>